(function () {
    'use strict';

    angular
        .module('fundSwapApp')
        .controller('FundSwapCancelDialogController', FundSwapCancelDialogController);

    FundSwapCancelDialogController.$inject = ['$scope', '$uibModalInstance', 'fundSwap', 'FundSwapService'];

    function FundSwapCancelDialogController($scope, $uibModalInstance, fundSwap, FundSwapService) {
        var cancelDlgCtr = this;
        cancelDlgCtr.cancel = cancel;
        cancelDlgCtr.cancelReason = cancelReason;
        cancelDlgCtr.errorMessage = null;
        cancelDlgCtr.cancelReasons = [];
        FundSwapService.query({uri: 'retention-cancel-reason'}, function (data) {
            cancelDlgCtr.cancelReasons = data;
        }, function (error) {
        });

        function cancelReason() {
            fundSwap.cancelCode = cancelDlgCtr.reason.retentionCancelId;
            fundSwap.cancelDesc = cancelDlgCtr.reason.retentionCancelDes;
            fundSwap.transaction.reasonCancel = cancelDlgCtr.reason.retentionCancelId + ' - ' + cancelDlgCtr.reason.retentionCancelDes;
            FundSwapService.post({uri: 'do-cancel'}, fundSwap,
                function (result) {
                    $uibModalInstance.close(result);
                }, function (error) {
                    if (error.data.errorDTO != null) {
                        cancelDlgCtr.errorMessage = error.data.errorDTO.message;
                    }
                });
        };

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
